// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grayBoxList {
  padding-left: 0;
}

.documentUpload .inlineEditor {
  width: 60%;
}

.documentUpload .fileList .editIcon img {
  height: 2rem;
  width: 2rem;
}

.documentUpload .fileList .icon img {
  height: 2rem;
  width: 2rem;
}

.documentUpload .fileList .name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 60%;
  display: inline-block;
}

.grayBoxList .grayBox {
  list-style-type: none;
  background-color: #eeeeee;
  border: 1px solid #e3e3e3;
  height: 3.5rem;
  position: relative;
  padding-left: 1rem;
  padding-top: 0.6rem;
  padding-bottom: 0.5rem;
  margin-bottom: 0.5rem;
}

.documentUpload .file span {
  margin-right: 0.5rem;
}

.grayBoxList .grayBox .deleteIcon {
  position: absolute;
  top: 1rem;
  right: 1rem;
}

.documentUpload .resourceLaunch:hover .resourceLaunchToolTip {
  visibility: visible;
}

.documentUpload .resourceLaunch .resourceLaunchToolTip {
  visibility: hidden;
  width: 120px;
  background-color: white;
  color: black;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;
  position: absolute;
  z-index: 1;
  border-color: #b6b6b6;
  border-width: 0.5px;
  border-style: solid;
  padding: 2px 2px;
}

/*Changing the z-index on bootstrap modal backdrop will affect the fade animations on the modals.
DO NOT change the default classes that come with bootstrap*/

/*.modal-backdrop {
    z-index: -1;
}*/
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/components/documentUpload.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;2DAC2D;;AAE3D;;EAEE","sourcesContent":[".grayBoxList {\n  padding-left: 0;\n}\n\n.documentUpload .inlineEditor {\n  width: 60%;\n}\n\n.documentUpload .fileList .editIcon img {\n  height: 2rem;\n  width: 2rem;\n}\n\n.documentUpload .fileList .icon img {\n  height: 2rem;\n  width: 2rem;\n}\n\n.documentUpload .fileList .name {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 60%;\n  display: inline-block;\n}\n\n.grayBoxList .grayBox {\n  list-style-type: none;\n  background-color: #eeeeee;\n  border: 1px solid #e3e3e3;\n  height: 3.5rem;\n  position: relative;\n  padding-left: 1rem;\n  padding-top: 0.6rem;\n  padding-bottom: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.documentUpload .file span {\n  margin-right: 0.5rem;\n}\n\n.grayBoxList .grayBox .deleteIcon {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n}\n\n.documentUpload .resourceLaunch:hover .resourceLaunchToolTip {\n  visibility: visible;\n}\n\n.documentUpload .resourceLaunch .resourceLaunchToolTip {\n  visibility: hidden;\n  width: 120px;\n  background-color: white;\n  color: black;\n  text-align: center;\n  padding: 5px 0;\n  border-radius: 6px;\n  position: absolute;\n  z-index: 1;\n  border-color: #b6b6b6;\n  border-width: 0.5px;\n  border-style: solid;\n  padding: 2px 2px;\n}\n\n/*Changing the z-index on bootstrap modal backdrop will affect the fade animations on the modals.\nDO NOT change the default classes that come with bootstrap*/\n\n/*.modal-backdrop {\n    z-index: -1;\n}*/\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
